import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SectionHeaderProps {
  title: string;
  icon?: LucideIcon;
  iconNode?: ReactNode;
  description?: string;
  trailing?: ReactNode;
  className?: string;
}

export default function SectionHeader({
  title,
  icon: Icon,
  iconNode,
  description,
  trailing,
  className,
}: SectionHeaderProps) {
  return (
    <div className={cn('flex items-start justify-between gap-4', className)}>
      <div>
        <h2 className="inline-flex items-center gap-2 text-xl font-semibold">
          {Icon ? (
            <Icon className="h-5 w-5 text-primary" />
          ) : (
            <span className="inline-flex [&_svg]:h-5 [&_svg]:w-5 [&_svg]:text-primary">{iconNode}</span>
          )}
          {title}
        </h2>
        {description && <p className="mt-1 text-xs text-muted-foreground">{description}</p>}
      </div>
      {trailing}
    </div>
  );
}
